import { useI18n } from "vue-i18n";
// =============================================================================
// COMPOSABLE
// =============================================================================
export function useBillingFormatting() {
    const { t, locale } = useI18n();
    function money(amountMinor, currency) {
        return new Intl.NumberFormat(locale.value, {
            style: "currency",
            currency: currency || "USD",
        }).format((amountMinor ?? 0) / 100);
    }
    function dateLabel(value) {
        if (!value)
            return t("settings.billing.none");
        return new Intl.DateTimeFormat(locale.value, {
            year: "numeric",
            month: "short",
            day: "2-digit",
        }).format(new Date(value));
    }
    function statusLabel(status) {
        return t(`settings.billing.status.${status}`);
    }
    function modeLabel(mode) {
        return t(`settings.billing.modes.${mode === "onvo" ? "provider" : mode}`);
    }
    function actionLabel(code) {
        return t(`settings.billing.actions_recommended.${code}`);
    }
    function actionDescription(code) {
        return t(`settings.billing.actions_description.${code}`);
    }
    function invoiceLabel(status) {
        if (!status)
            return t("settings.billing.none");
        return t(`settings.billing.invoice_status.${status}`);
    }
    function priceSourceLabel(source) {
        return t(`settings.billing.price_source.${source}`, source);
    }
    function statusClass(status) {
        if (status === "past_due")
            return "bg-red-100 text-red-700";
        if (status === "grace")
            return "bg-amber-100 text-amber-700";
        if (status === "trialing")
            return "bg-blue-100 text-blue-700";
        if (status === "active")
            return "bg-egreen-100 text-egreen-700";
        if (status === "cancelled" || status === "paused") {
            return "bg-ewhite-100 text-eblack-500";
        }
        return "bg-eorange-100 text-eorange-700";
    }
    function actionClass(severity) {
        if (severity === "critical")
            return "bg-red-100 text-red-700";
        if (severity === "warning")
            return "bg-amber-100 text-amber-700";
        if (severity === "info")
            return "bg-blue-100 text-blue-700";
        return "bg-ewhite-100 text-eblack-500";
    }
    return {
        money,
        dateLabel,
        statusLabel,
        modeLabel,
        actionLabel,
        actionDescription,
        invoiceLabel,
        priceSourceLabel,
        statusClass,
        actionClass,
    };
}
export default useBillingFormatting;
